<ng-template>
  <div [class]="classContainer">
    <!-- title -->
    <div class="mb-5 text-5xl font-bold" *ngIf="title">
      {{ title | translate }}
    </div>

    <!-- message -->
    <treo-message
      class="w-3/4 m-auto text-left"
      [appearance]="message.appearance"
      [showIcon]="message.showIcon"
      [showButtonClose]="message.showButtonClose"
      [type]="message.type"
      *ngIf="message">
      <i
        treoMessageIcon
        [class]="message.customIcon"
        *ngIf="message.customIcon"></i>
      <div treoMessageTitle *ngIf="message.title">
        {{ message.title | translate }}
      </div>
      <div *ngIf="getContentType(message.content) == 'string'">
        {{ message.content | translate }}
      </div>
      <ul
        class="list-disc pl-3 text-left"
        *ngIf="getContentType(message.content) == 'array'">
        <li *ngFor="let item of message.content">{{ item | translate }}</li>
      </ul>
    </treo-message>

    <!-- subtitle -->
    <div class="font-medium text-gray-600" *ngIf="subtitle">
      {{ subtitle | translate }}
    </div>

    <!-- content -->
    <ng-content></ng-content>
  </div>
</ng-template>
